// extracted by mini-css-extract-plugin
export default {"holder":"BookCounter_holder__JtOt1"};